import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import type { TelegramAuthData } from '@telegram-auth/react';
import { useSearchParams } from 'next/navigation';
import { toast } from 'sonner';
import { authClient, useSession } from '~/shared/lib/auth';

export const useTelegramLogin = (): UseMutationResult<unknown, { status?: number }, TelegramAuthData> => {
    const searchParams = useSearchParams();
    const { refetch } = useSession();

    return useMutation({
        mutationFn: async payload => authClient.telegramAuth.login(payload),
        onSuccess(response) {
            if (response.data?.status) {
                refetch();

                const redirect = searchParams.get('redirect') ?? '/';
                setTimeout(() => {
                    window.location.replace(redirect);
                });
            }
        },
        onError(err) {
            const status = err?.status || 500;

            switch (status) {
                case 400:
                    toast.error('Неверные данные для входа через Telegram');
                    break;
                case 401:
                    toast.error('Не авторизован. Попробуйте снова.');
                    break;
                case 403:
                    toast.error('Доступ запрещен.');
                    break;
                case 404:
                    toast.error('Сервис аутентификации не найден.');
                    break;
                case 500:
                    toast.error('Серверная ошибка. Попробуйте позже.');
                    break;
                default:
                    toast.error('Не удалось войти через Telegram');
            }
        },
    });
};
